import { LoadableLazy } from '@confluence/loadable';

// Lazy load ShareNudgeSpotlight using repository pattern to avoid loading video assets for all users
export const LazyShareNudgeSpotlight = LoadableLazy({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-ShareNudgeSpotlight" */ '../src/ShareNudgeSpotlight.tsx'
			)
		).ShareNudgeSpotlight;
	},
	loading: ({ children }) => children, // Always render ShareButtonSection while loading
});
